module.exports = __webpack_public_path__ + "static/media/uploaded-icon.84fdaf8a.svg";